import { render, staticRenderFns } from "./CadastroConsulta.vue?vue&type=template&id=b9e1b22e&scoped=true&"
import script from "./CadastroConsulta.vue?vue&type=script&lang=js&"
export * from "./CadastroConsulta.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConsulta.vue?vue&type=style&index=0&id=b9e1b22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e1b22e",
  null
  
)

export default component.exports